import currency from 'currency.js';

export function getCurrency(amount: number, options: currency.Options = {}) {
  return currency(amount, options || { fromCents: true });
}

export function getFormattedDollars(amount: number, def: string | null = '0') {
  const num = getCurrency(amount, { fromCents: true }).dollars();

  return num || def;
}

export function getFormattedCents(amount: number, def: string | null = '00', trimZeros = false) {
  const num = getCurrency(amount, { fromCents: true }).cents();

  if (num === 0 && trimZeros) {
    return def;
  }

  return `.${num.toString().padStart(2, '0')}`;
}

export function getFormattedMoney(amount: number, suffix = '', trimZeros = false) {
  const currency = getCurrency(amount, { fromCents: true });

  if (trimZeros && currency.cents() === 0) {
    // the lib has a bug where we can't pass precision for some reason to formatting :/
    return currency.format().replace('.00', '') + suffix;
  }

  return currency.format() + suffix;
}
